import {Injectable,  NgModule} from '@angular/core';

@Injectable()
@NgModule()
export class AppConsts {
   static appBaseUrl: string;
   static imageBaseUrl: string;
}



// WEBPACK FOOTER //
// ./src/assets/AppConsts.ts